// @ts-nocheck
interface IsOnePercentDifference {
  differenceHigherThanOnePercent: boolean;
  differenceLowerThanOnePercent: boolean;
  differenceWithinOnePercent: boolean;
}

export function isOnePercentDifference(requestAmount: number, responseAmount: number): IsOnePercentDifference {
  const onePercentOfResponseAmount = responseAmount * 0.01;

  return {
    differenceHigherThanOnePercent: requestAmount > responseAmount + onePercentOfResponseAmount,
    differenceLowerThanOnePercent: requestAmount < responseAmount - onePercentOfResponseAmount,
    differenceWithinOnePercent:
      requestAmount <= responseAmount + onePercentOfResponseAmount &&
      requestAmount >= responseAmount - onePercentOfResponseAmount,
  };
}
